<iframe [src]='safeUrl' width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>
</iframe>
